import React, { useContext, useState, useEffect } from 'react'
import moment from 'moment'
import PrimaryButton from '../../../../../product/components/atoms/PrimaryButton'
import SecondaryButton from '../../../../../product/components/atoms/SecondaryButton'
import FullScreenPopup from '../../../../../product/components/organisms/FullScreenPopup'

import {
    mapData,
    dateTimeFormatFunction,
    handleRedirectInternal,
} from '../../../../../product/common/components'
import Uploader from '../../../../../product/common/uploader'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { LinearProgress } from '@mui/material'
import Loaders from '../../../../../product/components/molecules/Loaders'
import CustomSearch from '../../../../../product/components/molecules/CustomSearch'
import CustomTable from '../../../../../product/components/molecules/CustomTable'
import { Button } from '@mui/material'
import SettingContext from '../../../../../product/context/setting/settingContext'

const LoginInfo = (props) => {
    const settingcontext = useContext(SettingContext)

    const {
        searchTableAction,
        updateConfigColumn,
        searchTableFetch,
        search_fetch_data,
        responseStatus: responseStatusSetting,
        clearResponse: clearResponseCommuncation,
    } = settingcontext

    const [isLoading, setIsLoading] = useState(true)

    const data = props.data
    const toggleFullScreenPopup = props.function

    const [tableBody, setTableBody] = useState([])
    const [primaryTable, setPrimaryTable] = useState('user_logins')

    const formik = useFormik({
        initialValues: {
            page: 1,
            limit: 20,
            order: '',
            orderby: '',
            filters: {
                user_id: {
                    value: 0,
                    type: 'in',
                    field: 'uls.user_id',
                },
                emp_id: {
                    value: 0,
                    type: 'in',
                    field: 'el.emp_id',
                },
            },
            primaryTable: primaryTable,
        },
        onSubmit: (values) => {
            setIsLoading(true)
            searchTableFetch(values, primaryTable)
        },
    })

    useEffect(() => {
        console.log('dataCheck', data)
        // if (data.status === 'loginHistory') {
        setTableBody([])
        setIsLoading(true)
        formik.values.page = 1
        if (
            ['super_admin', 'admin', 'seller', 'employee'].includes(
                data?.as_employees_emp_type
            )
        ) {
            formik.values.filters.user_id.value = 0
            formik.values.filters.emp_id.value =
                data?.as_employees_id || data?.id || 0
            formik.values.primaryTable = 'employee_logins'
            setPrimaryTable('employee_logins')
            searchTableFetch(formik.values, 'user_logins')
        } else {
            formik.values.filters.user_id.value = data.id
            formik.values.filters.emp_id.value = 0
            formik.values.primaryTable = 'user_logins'
            setPrimaryTable('user_logins')
            searchTableFetch(formik.values, 'user_logins')
        }
        // }
        // return () => {
        //     setTableBody([])
        // }
    }, [data.id])

    useEffect(() => {
        return () => setIsLoading(false)
    }, [])

    useEffect(() => {
        if (search_fetch_data) {
            if (search_fetch_data.from === 'user_logins') {
                setTableBody(
                    search_fetch_data.records.length
                        ? search_fetch_data.records
                        : []
                )
                console.log('search_fetch_data', search_fetch_data)
                setIsLoading(false)
            }
        }
    }, [search_fetch_data])

    const tableValues = []

    tableValues.push({
        field: 'id',
        type: '',
        firstChild: true,
        sort: true,
        sortField: 'id',
        disablePadding: false,
        label: 'ID',
    })

    tableValues.push(
        {
            field: 'useragent',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'User Agent',
        },
        {
            field: 'ip',
            type: '',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'IP Address',
        }
    )

    tableValues.push({
        field: 'created_at',
        type: 'datetime',
        sort: true,
        firstChild: false,
        disablePadding: false,
        label: 'Login date',
    })

    const tableActions = []

    console.log('tableBody', tableBody)
    const searchInfo = null
    return (
        <>
            <div className="addUserModal customContainer">
                <div className="dashboard listing">
                    <CustomSearch searchInfo={searchInfo} formik={formik} />
                    <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4 mb-4"></div>
                    {isLoading ? (
                        <Loaders name="table" isLoading={isLoading} />
                    ) : (
                        <CustomTable
                            formik={formik.values}
                            tableBody={tableBody}
                            tableValues={tableValues}
                            tableActions={tableActions}
                            allData={search_fetch_data}
                            changeTableFunction={searchTableFetch}
                        />
                    )}
                </div>
            </div>
        </>
    )
}

export default LoginInfo
